
import { defineComponent } from 'vue'
import { iFunction } from '../../FunctionsCatalog'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import Chips from 'primevue/chips'
import Dropdown from 'primevue/dropdown'
import Editor from 'primevue/editor'
import functionsCatalogGeneralTabDescriptor from './FunctionsCatalogGeneralTabDescriptor.json'
import Textarea from 'primevue/textarea'

export default defineComponent({
    name: 'function-catalog-general-tab',
    components: { Accordion, AccordionTab, Chips, Dropdown, Editor, Textarea },
    props: { propFunction: { type: Object }, readonly: { type: Boolean }, functionTypes: { type: Array }, propKeywords: { type: Array } },
    data() {
        return {
            functionsCatalogGeneralTabDescriptor,
            selectedFunction: {} as iFunction,
            descriptionDirty: false,
            showDescriptionSource: false,
            showBenchmarksSource: false
        }
    },
    created() {
        this.loadFunction()
    },
    methods: {
        loadFunction() {
            this.selectedFunction = this.propFunction as iFunction
            if (this.selectedFunction.tags && this.selectedFunction.tags[0] === '') {
                this.selectedFunction.tags = []
            }
        }
    }
})
